<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-10 10:21:26
 * @FilePath: \mrc-ess-fronted\src\Page\Ess\Announcement\components\viewAnnouncement.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-09 13:14:29
-->
<template>
  <normalDialog
    :title="title"
    @close="closeDialog"
    width="600"
    pad="0"
    :dialog="show"
    :show_title="false"
  >
    <template v-slot:content>
      <v-boilerplate class="pa-0" type="article , actions" v-if="!Data">
      </v-boilerplate>
      <v-container fluid v-if="Data" class="pa-5">
        <v-sheet class="text-h4 text--primary px-3 py-2">{{
          Data.message_title
        }}</v-sheet>
        <v-sheet class="text-body-2 text-right text--secondary px-3">{{
          $getDateTime(Data.send_start_utc_datetime, "YYYY/MM/DD")
        }}</v-sheet>
        <v-sheet
          v-html="Data.message_content"
          min-height="150"
          class="pa-3 text-body-1"
        >
          {{ Data.message_content }}
        </v-sheet>
        <v-sheet v-if="Number(Data.read_flag)" class="px-3 my-0 mx-0">
          <v-checkbox
            v-model="Data.read_flag"
            :disabled="true"
            color="primary"
            :label="$t('label_essweb_Announcement_dialog_hasBeenReadLabel')"
          ></v-checkbox>
        </v-sheet>
        <v-sheet
          v-if="
            Number(Data.read_flag) == 0 &&
            canEdit &&
            Number(Data.is_confirm_read)
          "
          class="px-3 my-0 mx-0"
        >
          <v-checkbox
            v-model="sendReceipt"
            :disabled="false"
            color="primary"
            :label="
              $t('label_essweb_Announcement_dialog_sendReceiptToSenderLabel')
            "
          ></v-checkbox>
        </v-sheet>
        <v-sheet class="d-flex flex-row justify-space-around">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDialog">{{
            $t("label_essweb_form_tools_oKBtnLabel")
          }}</v-btn>
        </v-sheet>
      </v-container>
    </template></normalDialog
  >
</template>
<script>
export default {
  name: "viewAnnouncement",
  components: {
    // extends v-skeleton-loader
    VBoilerplate: {
      functional: true,
      render(h, { data, props, children }) {
        return h(
          "v-skeleton-loader",
          {
            ...data,
            props: {
              boilerplate: true,
              elevation: 2,
              ...props,
            },
          },
          children
        );
      },
    },
  },
  props: {
    show: { default: false, type: [Boolean, Number] },
    curUuid: { default: null, type: [String, Number] },
    canEdit: { default: false, type: [Boolean, Number] },
  },
  computed: {},
  watch: {
    curUuid(val) {
      if (val) {
        this.getDetail(val);
      }
    },
    show(val) {
      if (!val) {
        this.Data = null;
        this.sendReceipt = false;
      }
    },
  },
  data() {
    return {
      title: "",
      Data: null,
      sendReceipt: false,
    };
  },
  methods: {
    closeDialog: function () {
      if (this.canEdit && this.sendReceipt) {
        //发送回执
        this.hasReaded(this.curUuid);
      } else this.$emit("close");
    },
    hasReaded: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/read/",
        data: { uuid: uuid },
        type: "client",
      }).then((res) => {
        this.$emit("close");
      });
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement",
        url: "/announcement/get-details/",
        data: { uuid: uuid },
        type: "client",
      }).then((res) => {
        if (res.data.read_flag !== undefined)
          res.data.read_flag = Number(res.data.read_flag);
        that.Data = res.data;
        // if (!Number(res.data["read_flag"]) && !this.canEdit)
        //   that.hasReaded(uuid);
      });
    },
  },
};
</script>
